import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageCircle } from "lucide-react";

const LABEL = { granted: "Subscribed", granted_historical: "Subscribed (Superchat history)", withdrawn: "Unsubscribed", suppressed: "Blocked",
  unevidenced: "Consent pending verification", unknown: "Consent pending verification" };

export function CustomerWhatsAppBadge({ customerId }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/wa/customers/${customerId}/whatsapp`).then((r) => setD(r.data)).catch(() => setD(null)); }, [customerId]);
  if (!d?.enabled || !d.contacts.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5 mt-1" data-testid="customer-whatsapp-badge">
      {d.contacts.map((c) => (
        <span key={c.msisdn} data-testid={`customer-whatsapp-${c.msisdn}`}
          className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${c.eligible ? "bg-emerald-50 text-emerald-700" : ["withdrawn", "suppressed"].includes(c.consent) ? "bg-rose-50 text-rose-700" : "bg-amber-50 text-amber-700"}`}>
          <MessageCircle className="w-3.5 h-3.5" /> WhatsApp {c.msisdn} · {LABEL[c.consent] || c.consent}
        </span>
      ))}
      {(d.campaigns || []).slice(0, 3).map((h) => (
        <span key={`${h.campaign_id}-${h.sent_at}`} className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs bg-slate-100 text-slate-600" data-testid={`customer-whatsapp-campaign-${h.campaign_id}`}>
          {h.campaign_name || "Campaign"} · {h.status}{h.unique_clicked ? " · clicked" : ""}{h.replied_at ? " · replied" : ""}{h.simulated ? " · test" : ""}
        </span>
      ))}
    </div>
  );
}
